class InfoCollapse {
    constructor() {
        this.setInfoCollapse();
    }

    setInfoCollapse() {
        const questionElements = document.querySelectorAll('.info-collapse-js .question-container');
        questionElements.forEach((questionElement) => {
            const question = questionElement.querySelector('.question');
            question.addEventListener('click', () => this.toggleQuestion(questionElement));
        });
    }

    toggleQuestion(questionElement) {
        const isOpening = !questionElement.classList.contains('open');
        if (isOpening) {
            const container = questionElement.closest('.info-collapse-js');
            container.querySelectorAll('.question-container.open').forEach((openElement) => {
                if (openElement !== questionElement) {
                    openElement.classList.remove('open');
                }
            });
        }

        questionElement.classList.toggle('open');

        // Allow time for the FAQ animation to complete before refreshing ScrollTrigger
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 700);

        // Extra timeout to ensure scroll trigger refreshes after any potential animation has completed
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 2000);
    }
}
new InfoCollapse();
